import { render, staticRenderFns } from "./zyrzlink.vue?vue&type=template&id=c47f4f10"
import script from "./zyrzlink.vue?vue&type=script&lang=js"
export * from "./zyrzlink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports